import React from "react";

const PowerAppDeleteTask= ({app}) => {

    return (
        <div style={{margin: "0 10px"}}>
            Deletion request of active <b>{app.type} "{app.name}"</b> has been requested on your environment.
        </div>
    );
}

export default PowerAppDeleteTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/ChangeValues/PowerAppDeleteTask.js